import homelineup from '../../../../core/datasources/homelineup';

const extractLineupIds = (player) => {
    return player && player.person && player.person.id;
};
const EMPTYARR = [];

const lineupDataRequestAction = () => {
    return (dispatch, getState, { componentDataEngine }) => {
        const state = getState();

        const {
            gumbo: {
                gamePk,
                liveData: {
                    boxscore: {
                        teams: {
                            away = {},
                            home = {}
                        } = {}
                    } = {}
                } = {},
                gameData: {
                    game: {
                        seasonDisplay,
                        type
                    }
                } = {}
            } = {},
            config: {
                language = 'en'
            } = {}
        } = state;
        const gameTypeList = [type];
        const awayBoxscoreBattersAvailable = !!(away?.batters?.length);
        const homeBoxscoreBattersAvailable = !!(home?.batters?.length);

        return componentDataEngine.fetch('schedule', { gamePk, language }).then((scheduleRes) => {
            const schedule = scheduleRes?.data || {};
            const scheduleAwayLineup = (schedule?.teams?.away && schedule?.teams?.away?.lineup) || [];
            const scheduleHomeLineup = (schedule?.teams?.home && schedule?.teams?.home?.lineup) || [];
            const awayLineup = awayBoxscoreBattersAvailable ? away.batters.map(extractLineupIds) : scheduleAwayLineup.length ? scheduleAwayLineup.map(extractLineupIds) : EMPTYARR;
            const homeLineup = homeBoxscoreBattersAvailable ? home.batters.map(extractLineupIds) : scheduleHomeLineup.length ? scheduleHomeLineup.map(extractLineupIds) : EMPTYARR;
            componentDataEngine.store(scheduleRes);
            const awayLineupExists = !!(awayLineup.length);
            const homeLineupExists = !!(homeLineup.length);
            const apicalls = [];

            if (awayLineupExists) {
                apicalls.push(componentDataEngine.fetch('awaylineup', {
                    season: seasonDisplay,
                    playerId: awayLineup,
                    gameType: '[' + encodeURIComponent(gameTypeList) + ']',
                    gamePk
                }));
            }

            if (homeLineupExists) {
                apicalls.push(componentDataEngine.fetch('homelineup', {
                    season: seasonDisplay,
                    playerId: homeLineup,
                    gameType: '[' + encodeURIComponent(gameTypeList) + ']',
                    gamePk
                }));
            }

            if (apicalls.length > 0) {
                return Promise.allSettled(apicalls).then((arr) => {
                    for (let i = 0; i < arr.length; i++) {
                        componentDataEngine.store(arr[i].value);
                    }
                }).catch((error) => {
                    // console.log('errrr', error)
                });
            } else {
                return Promise.resolve();
            }
        });
    };
};

export default lineupDataRequestAction;
